import { createTheme } from '@mui/material/styles';
import React from 'react';
import MotionGrow, { MotionPop } from './components/motion/MotionGrow';
import { AnimatedCheckboxIcon } from './components/motion/MotionExtras';
import MotionAutocompletePopper from './components/motion/MotionAutocompletePopper';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: 'var(--type-display)',
      fontWeight: 700,
    },
    h2: {
      fontSize: 'var(--type-h1)',
      fontWeight: 700,
    },
    h3: {
      fontSize: 'var(--type-h2)',
      fontWeight: 700,
    },
    h4: {
      fontSize: 'var(--type-h3)',
      fontWeight: 600,
    },
    h5: {
      fontSize: 'var(--type-body)',
      fontWeight: 600,
    },
    h6: {
      fontSize: 'var(--type-small)',
      fontWeight: 600,
    },
    body1: {
      fontSize: 'var(--type-body)',
      fontWeight: 400,
    },
    body2: {
      fontSize: 'var(--type-small)',
      fontWeight: 400,
    },
    caption: {
      fontSize: 'var(--type-caption)',
      fontWeight: 400,
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            outline: '2px solid currentColor',
            outlineOffset: 2,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    // Every menu, select list, popover and autocomplete list shares one grow-from-trigger
    // motion (src/components/motion/MotionGrow.tsx); individual sx styles are untouched.
    MuiPopover: {
      defaultProps: {
        TransitionComponent: MotionGrow,
      },
    },
    MuiMenu: {
      defaultProps: {
        TransitionComponent: MotionGrow,
      },
    },
    // Select lists open attached below their field, left-aligned (MUI's default overlays the
    // field so the selected item sits on top of it). Sites passing their own MenuProps set this too.
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          slotProps: { paper: { sx: { mt: '6px' } } },
        },
      },
    },
    // Dialogs grow in from slightly smaller on the shared spring instead of a plain fade.
    MuiDialog: {
      defaultProps: {
        TransitionComponent: MotionPop,
      },
    },
    // Checked checkboxes fill in and draw their tick (same look as MUI's icon).
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: React.createElement(AnimatedCheckboxIcon),
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        PopperComponent: MotionAutocompletePopper,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
